import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconUserRound: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2444 0.5C5.45478 0.5 0.744415 5.21036 0.744415 11C0.744415 16.7896 5.45478 21.5 11.2444 21.5C17.0341 21.5 21.7444 16.7896 21.7444 11C21.7444 5.21036 17.0341 0.5 11.2444 0.5ZM8.70927 6.39716C9.34886 5.71921 10.2489 5.34615 11.2444 5.34615C12.2399 5.34615 13.1319 5.72173 13.774 6.40322C14.4247 7.0938 14.7412 8.02163 14.6665 9.01913C14.5171 11 12.9825 12.6154 11.2444 12.6154C9.50636 12.6154 7.96872 11 7.82232 9.01863C7.74812 8.01305 8.06413 7.08219 8.70927 6.39716ZM11.2444 19.8846H11.2444C8.84813 19.8862 6.55341 18.917 4.88384 17.198C5.35712 16.5231 5.96016 15.9492 6.65773 15.51C7.94449 14.6851 9.573 14.2308 11.2444 14.2308C12.9158 14.2308 14.5443 14.6851 15.8296 15.51C16.5277 15.949 17.1313 16.5229 17.605 17.198C15.9355 18.9172 13.6407 19.8864 11.2444 19.8846Z"
        fill="#1E2846"
      />
    </svg>
  </IconStyled>
);

IconUserRound.defaultProps = iconDefaultProps;
IconUserRound.displayName = 'IconUserRound';

export default IconUserRound;
